import React, { useEffect, Fragment } from 'react';
import { Box, Flex, Grid, Text, Button } from '@chakra-ui/react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const MLIcon = () => <svg width="14" height="10" viewBox="0 0 14 10" fill="none" data-id="element-3">
    <path d="M1.5 8.5C3 4 5 2 7 2s4 2 5.5 6.5" stroke="#0066CC" strokeWidth="2.5" strokeLinecap="round" fill="none" data-id="element-4" />
  </svg>;
export function ScrollPage() {
  useScrollReveal();
  useEffect(() => {
    document.title = 'La urgencia de decidir - Gustavo Soto Miño';
  }, []);
  return <Box bg="var(--white)" minH="100vh" w="full" overflowX="hidden" data-id="element-5">
      {/* ════════ 1. HERO ════════ */}
      <Box as="section" id="hero" bg="var(--off)" minH={{
      base: 'auto',
      md: '100vh'
    }} display="grid" gridTemplateColumns={{
      base: '1fr',
      md: '1fr 1fr'
    }} alignItems="center" position="relative" overflow="hidden" data-id="element-6">
        <Box position="absolute" inset={0} className="hero-texture" pointerEvents="none" data-id="element-7" />

        {/* Mobile order: right column (book) first */}
        <Box className="hero-right" bg="var(--stone)" h="100%" minH={{
        base: '60vw',
        md: '100vh'
      }} display="flex" alignItems="center" justifyContent="center" p={{
        base: '64px 48px',
        md: '64px 48px'
      }} position="relative" order={{
        base: -1,
        md: 2
      }} data-id="element-8">
          <Box className="r" data-d="2" position="relative" w="min(280px, 70%)" data-id="element-9">
            <Box position="absolute" top="-16px" right="-16px" bg="#fff" border="1px solid var(--rule)" borderRadius="999px" px="16px" py="6px" fontFamily="var(--mono)" fontSize="10px" letterSpacing=".14em" textTransform="uppercase" color="var(--body)" boxShadow="0 4px 16px rgba(0,0,0,.08)" whiteSpace="nowrap" zIndex={2} data-id="element-10">
              Disponible ahora
            </Box>
            <Box as="img" src="https://cdn.magicpatterns.com/uploads/i2LeqihrgfaYhYfx4xPW51/Screenshot_2026-06-05_at_11.41.40_AM.png" alt="Portada del libro La urgencia de decidir, de Gustavo Soto Miño" w="100%" borderRadius="3px 8px 8px 3px" boxShadow="-6px 0 0 rgba(0,0,0,.15), -12px 6px 24px rgba(0,0,0,.25), 0 24px 64px rgba(0,0,0,.20)" style={{
            display: 'block',
            objectFit: 'cover'
          }} data-id="element-11" />
          </Box>
        </Box>

        <Box className="hero-left" p={{
        base: '48px 24px 64px',
        md: 'clamp(48px, 8vw, 120px) clamp(32px, 5vw, 80px) clamp(48px, 8vw, 120px) clamp(32px, 6vw, 96px)'
      }} display="flex" flexDirection="column" justifyContent="center" position="relative" zIndex={1} order={{
        base: 1,
        md: 1
      }} data-id="element-12">
          <Text className="r" fontFamily="var(--mono)" fontSize="11px" letterSpacing=".22em" textTransform="uppercase" color="var(--muted)" mb="32px" data-id="element-13">
            Gustavo Soto Miño
          </Text>
          <Text as="h1" className="r" data-d="1" fontFamily="var(--serif)" fontSize="clamp(52px, 7vw, 96px)" fontWeight="700" lineHeight=".95" letterSpacing="-0.025em" color="var(--ink)" mb="8px" data-id="element-14">
            La urgencia
            <Text as="em" display="block" fontStyle="italic" fontWeight="400" fontSize="clamp(44px, 6vw, 80px)" data-id="element-15">
              de decidir.
            </Text>
          </Text>
          <Text className="r" data-d="2" fontFamily="var(--serif)" fontStyle="italic" fontSize="clamp(16px, 1.8vw, 22px)" color="var(--muted)" lineHeight="1.5" m="28px 0 48px" maxW="38ch" borderLeft="2px solid var(--rule)" pl="20px" data-id="element-16">
            Lo que la IA dejó al descubierto en el negocio del desarrollo
            digital.
          </Text>
          <Button as="a" href="https://www.mercadolibre.cl/la-urgencia-de-decidir--libro--gustavo-soto-mino/up/MLCU4042614701" target="_blank" rel="noopener noreferrer" className="r" data-d="3" display="inline-flex" alignItems="center" gap="12px" bg="var(--cta)" color="#fff" fontFamily="var(--sans)" fontSize="15px" fontWeight="500" px="32px" py="16px" h="auto" borderRadius="4px" w="fit-content" mb="16px" _hover={{
          bg: 'var(--cta-h)',
          transform: 'translateY(-1px)'
        }} transition="background .2s var(--ease), transform .15s var(--ease)" data-id="element-17">
            <Box w="22px" h="22px" borderRadius="4px" bg="#FFE600" display="grid" placeItems="center" flexShrink={0} data-id="element-18">
              <MLIcon data-id="element-19" />
            </Box>
            Comprar en MercadoLibre
          </Button>
          <Text className="r" data-d="4" fontSize="12px" color="var(--muted)" fontFamily="var(--mono)" letterSpacing=".04em" data-id="element-20">
            Disponible ahora · Envío a todo Chile
          </Text>
        </Box>
      </Box>

      {/* ════════ 2. HOOK ════════ */}
      <Box as="section" id="hook" bg="var(--white)" p="clamp(80px,12vh,140px) clamp(24px,5vw,80px)" data-id="element-21">
        <Box maxW="720px" mx="auto" textAlign="center" data-id="element-22">
          <Flex className="r" alignItems="center" justifyContent="center" gap="12px" fontFamily="var(--mono)" fontSize="10px" letterSpacing=".22em" textTransform="uppercase" color="var(--muted)" mb="32px" _before={{
          content: '""',
          flex: 1,
          maxW: '40px',
          h: '1px',
          bg: 'var(--rule)'
        }} _after={{
          content: '""',
          flex: 1,
          maxW: '40px',
          h: '1px',
          bg: 'var(--rule)'
        }} data-id="element-23">
            El argumento central
          </Flex>
          <Text as="h2" className="r" data-d="1" fontFamily="var(--serif)" fontStyle="italic" fontSize="clamp(28px, 4vw, 52px)" lineHeight="1.2" letterSpacing="-0.015em" color="var(--ink)" mb="28px" data-id="element-24">
            El verdadero problema nunca fue producir.
            <br data-id="element-25" />
            Fue decidir.
          </Text>
          <Text className="r" data-d="2" fontSize="clamp(15px,1.5vw,17px)" color="var(--body)" lineHeight="1.8" fontWeight="300" mb="48px" data-id="element-26">
            La IA no creó este problema. Lo heredó, lo amplificó, y lo hizo
            imposible de ignorar. Las organizaciones llevan años ejecutando
            decisiones que nadie declaró como decisiones — sin dueño, sin
            criterio explícito, sin fecha de vencimiento. Cuando la IA escala
            eso, el costo deja de ser invisible.
          </Text>
          <Box className="r" data-d="3" w="40px" h="2px" bg="var(--ink)" mx="auto" mb="48px" data-id="element-27" />

          <Grid className="r" data-d="3" templateColumns={{
          base: '1fr',
          sm: '1fr 1fr'
        }} gap="1px" bg="var(--rule)" border="1px solid var(--rule)" borderRadius="12px" overflow="hidden" textAlign="left" data-id="element-28">
            <Box bg="var(--white)" p="28px 32px" data-id="element-29">
              <Text fontFamily="var(--mono)" fontSize="10px" letterSpacing=".18em" textTransform="uppercase" color="var(--muted)" mb="12px" data-id="element-30">
                Si ya implementaste IA
              </Text>
              <Text fontSize="14px" color="var(--body)" lineHeight="1.7" data-id="element-31">
                El problema que ves no es técnico. Es decisional. El sistema
                heredó criterios que nadie validó y los ejecuta a escala.
              </Text>
            </Box>
            <Box bg="var(--white)" p="28px 32px" data-id="element-32">
              <Text fontFamily="var(--mono)" fontSize="10px" letterSpacing=".18em" textTransform="uppercase" color="var(--muted)" mb="12px" data-id="element-33">
                Si estás a punto de hacerlo
              </Text>
              <Text fontSize="14px" color="var(--body)" lineHeight="1.7" data-id="element-34">
                La velocidad que vas a ganar amplificará exactamente lo que no
                tengas resuelto. Antes de ejecutar, hay que decidir qué se
                decide.
              </Text>
            </Box>
          </Grid>
        </Box>
      </Box>

      {/* ════════ 3. DECISIONES ════════ */}
      <Box as="section" id="decisiones" bg="var(--off)" p="clamp(80px,12vh,140px) clamp(24px,5vw,80px)" data-id="element-35">
        <Box maxW="960px" mx="auto" data-id="element-36">
          <Grid templateColumns={{
          base: '1fr',
          md: '1fr 1fr'
        }} gap={{
          base: '24px',
          md: '48px'
        }} alignItems="end" mb="56px" data-id="element-37">
            <Text as="h2" className="r" data-d="1" fontFamily="var(--serif)" fontSize="clamp(32px,4.5vw,56px)" fontWeight="700" lineHeight="1.05" letterSpacing="-0.02em" data-id="element-38">
              Los cuatro tipos de decisiones
              <br data-id="element-39" />
              <Text as="em" fontStyle="italic" fontWeight="400" data-id="element-40">
                que el libro nombra.
              </Text>
            </Text>
            <Text className="r" data-d="2" fontSize="15px" color="var(--body)" lineHeight="1.75" fontWeight="300" data-id="element-41">
              Toda organización las tiene. La mayoría no sabe nombrarlas.
              Reconocer cuál enfrentas es la primera intervención.
            </Text>
          </Grid>

          <Grid templateColumns={{
          base: '1fr',
          sm: '1fr 1fr',
          md: 'repeat(4,1fr)'
        }} gap="12px" data-id="element-42">
            {[{
            n: '01 · Heredadas',
            title: 'Heredadas',
            body: 'Alguien las tomó antes. El sistema las adoptó como norma sin ratificarlas.',
            signal: "'siempre fue así'",
            delay: '1'
          }, {
            n: '02 · Diferidas',
            title: 'Diferidas',
            body: 'Nadie las tomó del todo. Los supuestos provisionales se volvieron permanentes.',
            signal: "'eso nunca quedó definido'",
            delay: '2'
          }, {
            n: '03 · Fragmentadas',
            title: 'Fragmentadas',
            body: 'Cada función decidió su tramo. Nadie gobernó el recorrido completo.',
            signal: "'cada equipo hizo lo suyo'",
            delay: '3'
          }, {
            n: '04 · Automatizadas',
            title: 'Automatizadas',
            body: 'Codificadas en prompts o modelos. Se ejecutan a escala. En silencio. Sin revisión.',
            signal: "'el modelo lo decidió'",
            delay: '4',
            urgent: true
          }].map((card, i) => <Flex key={i} className="r" data-d={card.delay} direction="column" gap="12px" bg={card.urgent ? 'var(--ink)' : 'var(--white)'} border="1px solid" borderColor={card.urgent ? 'var(--ink)' : 'var(--rule)'} borderRadius="10px" p="28px 22px" transition="box-shadow .2s var(--ease), transform .2s var(--ease)" _hover={{
            boxShadow: '0 8px 32px rgba(0,0,0,.07)',
            transform: 'translateY(-2px)'
          }} data-id="element-43">
                <Text fontFamily="var(--mono)" fontSize="10px" color={card.urgent ? 'rgba(255,255,255,.35)' : 'var(--muted)'} letterSpacing=".1em" data-id="element-44">
                  {card.n}
                </Text>
                <Text fontFamily="var(--serif)" fontSize="20px" fontWeight="700" color={card.urgent ? '#fff' : 'var(--ink)'} lineHeight="1.1" data-id="element-45">
                  {card.title}
                </Text>
                <Text fontSize="13px" color={card.urgent ? 'rgba(255,255,255,.6)' : 'var(--body)'} lineHeight="1.65" fontWeight="300" fontStyle="italic" data-id="element-46">
                  {card.body}
                </Text>
                <Text fontFamily="var(--mono)" fontSize="11px" color={card.urgent ? 'rgba(255,255,255,.45)' : 'var(--muted)'} bg={card.urgent ? 'rgba(255,255,255,.06)' : 'var(--off)'} borderRadius="6px" p="8px 12px" lineHeight="1.5" mt="auto" data-id="element-47">
                  {card.signal}
                </Text>
              </Flex>)}
          </Grid>
        </Box>
      </Box>

      {/* ════════ 4. CTA FINAL ════════ */}
      <Box as="section" id="final" bg="var(--ink)" p="clamp(80px,12vh,140px) clamp(24px,5vw,80px)" display="grid" gridTemplateColumns={{
      base: '1fr',
      md: '1fr 1fr'
    }} gap={{
      base: '48px',
      md: '80px'
    }} alignItems="center" position="relative" overflow="hidden" data-id="element-48">
        <Box position="absolute" top="-40%" right="-10%" w="60vw" h="60vw" borderRadius="50%" className="final-glow" pointerEvents="none" data-id="element-49" />

        <Box className="final-left" position="relative" zIndex={1} data-id="element-50">
          <Text as="h2" className="r" data-d="1" fontFamily="var(--serif)" fontSize="clamp(36px, 5vw, 64px)" fontWeight="700" lineHeight="1.0" letterSpacing="-0.025em" color="#fff" mb="8px" data-id="element-51">
            La urgencia{' '}
            <Text as="em" fontStyle="italic" fontWeight="400" color="rgba(255,255,255,.6)" data-id="element-52">
              de decidir.
            </Text>
          </Text>
          <Text className="r" data-d="2" fontSize="clamp(15px,1.5vw,18px)" color="rgba(255,255,255,.5)" lineHeight="1.7" fontWeight="300" m="28px 0 48px" maxW="42ch" data-id="element-53">
            Si sientes que algo en el sistema cambió y no puedes nombrarlo del
            todo — este libro fue escrito para ti.
          </Text>
          <Button as="a" href="https://www.mercadolibre.cl/la-urgencia-de-decidir--libro--gustavo-soto-mino/up/MLCU4042614701" target="_blank" rel="noopener noreferrer" className="r" data-d="3" display="inline-flex" alignItems="center" gap="12px" bg="#fff" color="var(--ink)" fontFamily="var(--sans)" fontSize="16px" fontWeight="600" px="36px" py="18px" h="auto" borderRadius="4px" w="fit-content" mb="20px" _hover={{
          opacity: 0.92,
          transform: 'translateY(-1px)'
        }} transition="opacity .2s, transform .15s var(--ease)" data-id="element-54">
            <Box w="24px" h="24px" borderRadius="4px" bg="#FFE600" display="grid" placeItems="center" flexShrink={0} data-id="element-55">
              <MLIcon data-id="element-56" />
            </Box>
            Comprar en MercadoLibre
          </Button>
          <Text className="r" data-d="4" fontFamily="var(--mono)" fontSize="11px" color="rgba(255,255,255,.25)" letterSpacing=".1em" data-id="element-57">
            Gustavo Soto Miño · Santiago de Chile, 2026
          </Text>
        </Box>

        <Box className="final-right r" data-d="2" display={{
        base: 'none',
        md: 'flex'
      }} alignItems="center" justifyContent="center" position="relative" zIndex={1} data-id="element-58">
          <Box position="relative" w="min(260px, 80%)" data-id="element-59">
            <Box position="absolute" bottom="-24px" right="-32px" w="70%" aspectRatio="6/9" bg="#2a2a2a" borderRadius="3px 6px 6px 3px" boxShadow="4px 8px 24px rgba(0,0,0,.4)" transform="rotate(8deg)" zIndex={-1} data-id="element-60">
              <Box position="absolute" top={0} left={0} right={0} h="2px" className="book-flat-gradient" data-id="element-61" />
            </Box>
            <Box as="img" src="https://cdn.magicpatterns.com/uploads/i2LeqihrgfaYhYfx4xPW51/Screenshot_2026-06-05_at_11.41.40_AM.png" alt="Portada del libro La urgencia de decidir, de Gustavo Soto Miño" w="100%" borderRadius="3px 8px 8px 3px" boxShadow="-4px 0 0 rgba(0,0,0,.4), 8px 16px 40px rgba(0,0,0,.5)" style={{
            display: 'block',
            objectFit: 'cover'
          }} data-id="element-62" />
          </Box>
        </Box>
      </Box>

      {/* ════════ FOOTER ════════ */}
      <Box as="footer" bg="#0A0A0A" p="28px clamp(24px,5vw,80px)" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap="12px" data-id="element-63">
        <Text fontFamily="var(--mono)" fontSize="11px" color="rgba(255,255,255,.2)" letterSpacing=".12em" textTransform="uppercase" data-id="element-64">
          © 2026 Gustavo Soto Miño
        </Text>
        <Text as="a" href="https://www.linkedin.com/in/gustavosoto/" target="_blank" rel="noopener noreferrer" fontFamily="var(--mono)" fontSize="11px" color="rgba(255,255,255,.35)" letterSpacing=".12em" textTransform="uppercase" transition="color .2s" _hover={{
        color: 'rgba(255,255,255,.7)'
      }} data-id="element-65">
          LinkedIn
        </Text>
      </Box>
    </Box>;
}